// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import React, { useEffect, useState, useCallback } from "react";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
import { withStore, useStore } from "../store";
import { get_getFaCheckItem } from "../api/uaapi/user";

import { Modal, ModalProps } from "antd";
import XtSvg from "../components/xt/svg";
import XtLoading from "../components/xt/loading";
import SvgClose from "../svg/close2";
import SvgArrowLeft from "../svg/arrowLeft";

import FaType1 from "./FaType1";
import FaType2 from "./FaType2";

import styles from "./index.module.scss";
import stylesCommon from "../common.module.scss";

export interface FaItemProps {
  msgType: string | number;
  validateItemType: number; //0=email, 1=mobile, 2=google
}

export interface FaCheckItemProps {
  faCheckId: string;
  faItems: FaItemProps[];
  faLastEnable?: boolean; //上次是否可用
  faType: number; //1=单项验证, 2=多项验证
  passkeyEnable: boolean; //通行密钥是否启用
  email?: string;
  mobile?: string;
  countryCode?: string;
}

export interface ModalTitleProps {
  label?: string;
  onClick?: () => void;
}

interface Props extends ModalProps {
  faBizType?: number;
  dynamicCodeType?: string;
  getFaCheckItemData?: FaCheckItemProps;
  successCallback?: (arg: any) => void;
  isDark?: boolean;
  userInfo?: any;
  msgSendDataObj?: any;
  //
  open?: boolean;
  onClose: () => void;
}

const Main: React.FC<Props> = ({ open, faBizType = 129, dynamicCodeType = "USER_2035", getFaCheckItemData, successCallback, isDark = false, userInfo, onClose, msgSendDataObj, ...rest }) => {
  const t = useTranslation();

  const { updateState } = useStore();
  useEffect(() => {
    updateState({ isDark, userInfo })
  }, [isDark, userInfo]);

  const [faCheckItemData, setFaCheckItemData] = useState<FaCheckItemProps | undefined>();
  const [disabled, setDisabled] = useState(false);

  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [modalTitle, setModalTitle] = useState<ModalTitleProps | undefined>();

  const handleAfterClose = useCallback(() => {
    setFaCheckItemData(undefined);
  }, []);
  const handleInitRequest = useCallback(() => {
    setLoading(true);
    setErrMsg("");
    get_getFaCheckItem({ params: { faBizType } })
      .then((data) => {
        setFaCheckItemData(data);
      })
      .catch((e) => {
        setFaCheckItemData(undefined);
        setErrMsg(e.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [faBizType]);
  const handleSuccess = useCallback(
    async (data?) => {
      try {
        successCallback && await successCallback(data);
      } catch (e) {
        //empty
      }
      try {
        await onClose();
      } catch (e) {
        //empty
      }
      setDisabled(false);
    },
    [onClose, successCallback]
  );

  useEffect(() => {
    if (!open) return;
    getFaCheckItemData ? setFaCheckItemData(getFaCheckItemData) : handleInitRequest();
  }, [open]);

  return (
    <Modal
      open={open}
      title={
        !modalTitle ? (
          t("@xt/Passkey.safeCodeTips")
        ) : (
          <>
            {!modalTitle.onClick ? (
              modalTitle.label || t("@xt/Passkey.safeCodeTips")
            ) : (
              <button className={cx(stylesCommon.btnTxt, styles.titleBtn)} disabled={disabled} onClick={modalTitle.onClick}>
                <SvgArrowLeft />
                &nbsp;&nbsp;
                <span>{modalTitle.label || t("@xt/Passkey.safeCodeTips")}</span>
              </button>
            )}
          </>
        )
      }
      width={400}
      centered
      maskClosable={false}
      closeIcon={<SvgClose />}
      className={styles.main}
      onCancel={() => !loading && !disabled && onClose()}
      afterClose={handleAfterClose}
      footer={null}
      {...rest}
    >
      {faCheckItemData === undefined && !!errMsg && (
        <div className={styles.retry}>
          <p>{errMsg}</p>
          <button className={cx(stylesCommon.btnTxt)} onClick={handleInitRequest}>
            {t("@xt/Passkey.retry")}
          </button>
        </div>
      )}

      {faCheckItemData && !/^(1|2)$/.test(faCheckItemData.faType + "") && (
        <div className={styles.retry}>
          <p>{`Error faType: ${faCheckItemData.faType}`}</p>
          <button
            className={cx(stylesCommon.btnTxt)}
            onClick={() => {
              setFaCheckItemData(undefined);
              handleInitRequest();
            }}
          >
            {t("@xt/Passkey.retry")}
          </button>
        </div>
      )}

      {faCheckItemData && faCheckItemData.faType === 1 && (
        <FaType1
          faBizType={faBizType}
          dynamicCodeType={dynamicCodeType}
          faCheckItemData={faCheckItemData}
          successCallback={handleSuccess}
          setDisabled={setDisabled}
          setModalTitle={setModalTitle}
          msgSendDataObj={msgSendDataObj}
        />
      )}
      {faCheckItemData && faCheckItemData.faType === 2 && (
        <FaType2
          faBizType={faBizType}
          dynamicCodeType={dynamicCodeType}
          faCheckItemData={faCheckItemData}
          successCallback={handleSuccess}
          setDisabled={setDisabled}
          setModalTitle={setModalTitle}
          msgSendDataObj={msgSendDataObj}
        />
      )}

      {loading && <XtLoading />}
    </Modal>
  );
};

export default withStore(Main);
